import Vue from 'vue'
import {mapGetters} from 'vuex'
import template from './_search.pug'
import BillingMovementsService from 'js/services/api/billing/movements.js'

const AVOIDED_TYPES = [
  19,
  14, // Precarga
  12, // Partial Validation
  99
]
export default Vue.extend({
  name: 'movements-history-search',
  template: template(),
  data() {
    return {
      dni: '',
      cardNumber: '',
      dniError: '',
      cardNumberError: '',
      formError: '',
      valido: false,
      searchError: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        totalElements: 0
      },
      loading: false
    }
  },
  computed: {
    showPagination() {
      return this.pagination.totalElements > 5;
    }
  },
  methods: {
    onlyNumbers(oldValue, value) {
      if (value === '') return ''
      if (value && String(value).trim().match(/^[0-9]*$/)) {
        return String(value).trim()
      }
      if (oldValue) {
        return String(oldValue).trim()
      }
      return ''
    },

    validateForm() {      
      this.cardNumberError = this.cardNumber ? '' : this.$t('movementsHistory.errorEmpty');
      this.dniError = this.dni ? '' : this.$t('movementsHistory.errorEmpty');
      this.formError = this.dniError || this.cardNumberError ? this.$t('movementsHistory.errorEmpty') : '';
      this.valido = !this.dniError && !this.cardNumberError;
      this.searchError = ''; // Limpiar error anterior
      // aqui emito la validacion, tanto si es falsa como verdad
      this.$emit('validation', this.valido); 

      if(this.valido){
        this.pagination.currentPage = 1;
        this.fetchMovements();
      }
    },

    fetchMovements() {
      this.loading = true;
      BillingMovementsService.index({
        document_number: this.dni,
        media_code: this.cardNumber,
        administrative_area_id: this.administrativeArea?.id,
        page: this.pagination.currentPage,
        per: this.pagination.limit,
        avoided_types: AVOIDED_TYPES
      }).then(response => {
        if(response.transactions && response.transactions.length === 0){
          this.$emit('sendMovements', [])
          this.pagination.totalElements = 0;
          return
        }
        this.pagination.totalElements = response.meta.total_count || response.transactions.length;
        this.$emit('sendMovements', response.transactions)
      }).catch(error => {
        // Si es un 404, mostrar mensaje de error sin redireccionar
        this.searchError = this.$t('movementsHistory.noMovementsFound')
        this.$emit('sendMovements', [])
        this.pagination.totalElements = 0;
      }).finally(() => {
        this.loading = false;
      });
    },

    cancelForm() {
      this.dni = ''
      this.cardNumber = ''
      this.dniError = ''
      this.cardNumberError = ''
      this.formError = ''
      this.searchError = ''
      this.valido = false
      this.pagination = {
        currentPage: 1,
        limit: 10,
        totalElements: 0
      }
      this.$emit('validation', this.valido);
    },

    changeLimit(limit) {
      this.pagination.limit = limit;
      this.pagination.currentPage = 1;
      this.fetchMovements();
    },

    changePage(page) {
      this.pagination.currentPage = page;
      this.fetchMovements();
    }
  }
})